import { useLiveQuery } from 'dexie-react-hooks';

import db from '../lib/db';

const EMPTY_TEMPLATE_WIDGET_SIGNAL = '';

export default function useWorkspaceTemplateWidgetSignal(workspaceId) {
  return useLiveQuery(
    async () => {
      if (!workspaceId) return EMPTY_TEMPLATE_WIDGET_SIGNAL;

      const widgets = await db.widgets.where('workspace_id').equals(workspaceId).toArray();
      return widgets
        .filter((widget) => widget.template_runtime_state != null)
        .map((widget) => [widget.id, widget.updated_at, widget.template_runtime_state].join(':'))
        .sort()
        .join('|');
    },
    [workspaceId],
    EMPTY_TEMPLATE_WIDGET_SIGNAL,
  );
}
